import React, { useEffect, useState} from 'react'
import styles from './CompanyFormsPage.module.css'
import {Button, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {Alert, Dialog, Divider, FormControl, Grid} from "@mui/material";
import AutocompleteSelect from "../../../components/common/inputs/AutoCompleteSelectInput";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HookForm from "../../../components/common/HookForm";
import {useForm} from "react-hook-form";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";
import TextInput from "../../../components/common/inputs/TextInput";
import {checkPasswordsMatch} from "../../../util/formValidation";

interface FormData {
    divisionid: number
    woid: number
    pmid: number
    addressid: number
    generalformsnamebase: string
}
const BaseFileName = (params) => {
    const formMethods = useForm<FormData>()
    const { setValue, watch, reset } = formMethods
    const watchgeneralformsnamebase = watch('generalformsnamebase')


    useEffect(() => {
        if (params.findBaseFilename == true) {
            reset({
                generalformsnamebase: params.generalformsnamebase
            })
        }
    }, [params.findBaseFilename])

    const onSubmit = async () => {
        params.setFindBaseFilenameString(watchgeneralformsnamebase)
        params.setFindBaseFilename(false)
    }

    return (
            <Dialog fullWidth={true} open={params.findBaseFilename}>
                <DialogTitle>File Name Selection</DialogTitle>
                <DialogContent>
                    <HookForm
                        methods={formMethods}
                        onSubmit={onSubmit}
                        className={styles.form}>

                        <FormControl fullWidth>
                            <TextInput
                                name="generalformsnamebase"
                                label="Base File Name"
                                required={true}
                            />
                        </FormControl>

                        <DialogActions>
                            <Button onClick={()=> {
                                // params.setBaseFilenameString(null)
                                params.setFindBaseFilename(false)
                            }} variant="contained" style={{width: '100%'}}>
                                Cancel
                            </Button>
                            <Button disabled={watchgeneralformsnamebase?.length <= 0} onClick={()=> {onSubmit()}} type="submit" variant="contained" style={{width: '100%'}}>
                                Open Document
                            </Button>
                        </DialogActions>
                    </HookForm>
                </DialogContent>
            </Dialog>
    )
}
export default BaseFileName